import { render } from "./AboutUs.vue?vue&type=template&id=4c1aeb8c&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=4c1aeb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1aeb8c"]])

export default __exports__